import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { classList } from 'utils/componentsCommon';

const UploadButton = ({ children, className, size, color, variant, noshadow, inputId, acceptMimeTypes, onFilesChoosenHandler, ...props }) => {
    const classNames = classList(
        'uploadButton',
        className);

    const labelClassNames = classList(
        size && `size-${size}`,
        color && `color-${color}`,
        variant && `variant-${variant}`,
        noshadow && 'noshadow',
        className);

    const [inputIdInternal, setInputIdInternal] = useState(inputId);

    useEffect(() => {
        if (!inputIdInternal || inputIdInternal === '') {
            setInputIdInternal(`uploadButton${ Math.floor(Math.random() * 100) + 1}`);
        }
    }, [inputIdInternal]);

    const onChangeHandler = (event) => {
        onFilesChoosenHandler(event.target.files);
    };

    return <div className={ classNames } { ...props }>
        <input type="file" accept={ acceptMimeTypes } id={ inputIdInternal } onChange={ onChangeHandler } />
        <label htmlFor={ inputIdInternal } className={ labelClassNames }>{ children }</label>
    </div>;
};

UploadButton.defaultProps = {
    size: 'medium',
    color: 'default',
    variant: 'contained',
    noshadow: false,
};

UploadButton.propTypes = {
    children: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    variant: PropTypes.string,
    noshadow: PropTypes.bool,
    inputId: PropTypes.string,
    acceptMimeTypes: PropTypes.string,
    onFilesChoosenHandler: PropTypes.func,
};

export default UploadButton;
